export default "__VITE_ASSET__D789HlDD__"